import axios from './index';

export const getConversionRequest = (values) =>
  axios.get(
    `/v1/admins/conversions/get/conversions/-/${values?.vendorID || '-'}/${values?.adID || '-'}/${
      values?.from || '-'
    }/${values?.to || '-'}/-/-`
  );
